import { ShapeIcon as BaseShapeIcon } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const ShapeIcon = styled(BaseShapeIcon)`
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacings.xs5};
`;
